import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Home = () => {
  const benefits = [
    {
      title: 'Protect Your Belongings',
      description: 'Secure your personal items with unique QR codes that help return lost items.',
      icon: '🔒'
    },
    {
      title: 'Easy to Use',
      description: 'Generate QR codes in seconds and attach them to your valuable possessions.',
      icon: '⚡'
    },
    {
      title: 'Customizable Messages',
      description: 'Set personalized messages that appear when someone scans your QR code.',
      icon: '✏️'
    },
    {
      title: 'Privacy Control',
      description: 'You decide what information to share when your QR code is scanned.',
      icon: '🛡️'
    }
  ];

  return (
    <Container>
      <section className="py-5 text-center">
        <h1>Secure Your Belongings with QR Security</h1>
        <p className="lead">
          Generate unique QR codes for your personal items and protect them with our anti-fool QR code technology.
        </p>
        <div className="d-grid gap-2 d-sm-flex justify-content-sm-center mt-4">
          <Button as={Link} to="/register" variant="primary" size="lg" className="px-4 gap-3">
            Get Started
          </Button>
          <Button as={Link} to="/about" variant="outline-secondary" size="lg" className="px-4">
            Learn More
          </Button>
        </div>
      </section>

      <section className="py-5">
        <h2 className="text-center mb-4">Benefits of Our Service</h2>
        <Row xs={1} md={2} lg={4} className="g-4">
          {benefits.map((benefit, idx) => (
            <Col key={idx}>
              <Card className="h-100 text-center">
                <Card.Body>
                  <div className="display-1 mb-3">{benefit.icon}</div>
                  <Card.Title>{benefit.title}</Card.Title>
                  <Card.Text>{benefit.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </section>

      <section className="py-5">
        <h2 className="text-center mb-4">How It Works</h2>
        <Row className="align-items-center">
          <Col md={6}>
            <img 
              src="https://via.placeholder.com/600x400?text=QR+Code+Example" 
              alt="QR Code Example" 
              className="img-fluid rounded"
            />
          </Col>
          <Col md={6}>
            <h3>Simple 3-Step Process</h3>
            <ol className="fs-5">
              <li className="mb-3">Register an account and create your profile</li>
              <li className="mb-3">Generate custom QR codes with your message</li>
              <li className="mb-3">Print and attach QR codes to your belongings</li>
            </ol>
            <p>
              When someone scans your QR code, they'll see your custom message and contact information (if you choose to share it).
            </p>
            <Button as={Link} to="/generate-qr" variant="success" size="lg">
              Generate Your QR Code Now
            </Button>
          </Col>
        </Row>
      </section>
    </Container>
  );
};

export default Home;